import React from 'react';
import ReactPlayer from 'react-player';
import Header from './Header';
import Gallery01 from './Gallery01';
import Gallery02 from './Gallery02';
import Gallery03 from './Gallery03';
import Gallery04 from './Gallery04';
import Gallery05 from './Gallery05';
import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <Header />
      <S.Content>
        <S.Text>
          <p
            className="drop-caps wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Rei Kawakubo chamou o inverno 2022 de sua Comme des Garçons de Black
            Rose (rosa negra). A apresentação aconteceu em Tóquio, sem plateia,
            e foi registrada em fotos e vídeos – há dois anos, a marca não
            realiza desfiles presenciais devido à pandemia de Covid-19. Em um
            e-mail enviado à imprensa, a diretora de criação explica que a
            beleza sombria dessa flor “simboliza coragem, resistência e
            liberdade”.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            É tentador, e fácil, associar tais palavras à guerra entre Rússia e
            Ucrânia. No entanto, a estilista japonesa é conhecida por se desviar
            de qualquer comentário ou referência a acontecimentos atuais. O que
            não quer dizer que não esteja ciente e sensível a eles, a seus
            impactos sociais, culturais e econômicos.
          </p>
        </S.Text>
        <S.WrapperWrapper>
          <S.VideoWrapper
            className="wow animate__animated animate__zoomIn"
            data-wow-duration="1s"
          >
            <ReactPlayer
              className="react-player"
              url="https://www.youtube.com/watch?v=n0lgFKJlN0w"
              width="100%"
              height="100%"
              controls
            />
          </S.VideoWrapper>
        </S.WrapperWrapper>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Sempre evasiva, Rei não diz o que estava em seus pensamentos quando
            começou a esboçar a mais recente coleção. Ainda assim, é possível
            pinçar algumas inspirações. A trilha sonora, por exemplo, é uma
            música de resistência muito conhecida na Irlanda. Com nome de Roisin
            dubh (pequena rosa negra), essa canção romântica tem origem no
            século 16 e ganhou todo um outro significado durante a guerra de
            independência do país, entre 1919 a 1921. No vídeo, ela é
            interpretada pelo flautista irlandês Ciaran Carlin.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Contudo, é pouco provável que a estilista dedicasse uma coleção
            inteira à república irlandesa ou que fizesse disso uma alusão à
            soberania territorial e política da Ucrânia. Independência e
            liberdade são assuntos importantes aqui, mas em relação ao nosso
            corpo como escolhemos (ou não) apresentá-lo ao mundo. E, nesse
            sentido, o inverno 2022 da Comme des Garçons pode ser visto como um
            grande resumo de tudo o que a marca e a sua criadora representam
            para a história da moda e do vestuário: irreverência, subversão e
            inovação.
          </p>
        </S.Text>
        <Gallery01 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Vamos começar pela cartela de cores. Entre os muitos tons de cinza,
            destaca-se a maneira como preto, branco e vermelho pontuam boa parte
            dos looks. É uma combinação cromática simbólica desde a Antiguidade
            até a Idade Média. As três tonalidades foram a base de muitas
            doutrinas sociais, espirituais e políticas. Cada uma dessas cores já
            significou sagrado e profano, dor e glória, bem e mal, vida e morte,
            amor e ódio.
          </p>
        </S.Text>
        <Gallery02 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Ao longo da história, o preto e o branco, especificamente, passaram
            por mil e uma interpretações – todas com profundas implicações na
            vida das pessoas e de quem podia ou não vesti-las. Rei Kawakubo, que
            raramente usa outra cor, sabe bem das implicâncias e influências
            cromáticas no nosso guarda-roupa. Ao longo dos seus 53 anos de
            carreira, não foram poucas as vezes que ela virou de cabeça para
            baixo algumas tradições e convenções cromáticas das roupas. É só
            lembrar as incontáveis noivas de preto que já cruzaram sua
            passarela. Ou, mais ainda, da coleção agoniante de vestidos brancos
            aprisionantes e opressores.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Os tecidos (ou o que se entende por eles) também desempenham um
            papel relevante na desconstrução criativa da Comme des Garçons. Já
            na estreia da marca na semana de moda de Paris, em 1981, a estilista
            chocou crítica e consumidores com suas roupas de camadas
            desgastadas, desbotadas e rasgadas. Os looks do inverno 2022 são bem
            mais elaborados e sofisticados – as jaquetas de alfaiataria que o
            digam. Ainda assim, há uma estranheza na escolha de materiais. Entre
            eles, destacam-se aqueles com a aparência de feltro e o com
            padronagem tipo colmeia de abelha.
          </p>
        </S.Text>
        <Gallery03 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Se antes a ideia era ressignificar o que se entende por uma peça de
            luxo, agora a intenção é buscar novas formas de fazer roupa. Há
            algumas coleções, Rei se diz um tanto cansada pela limitação do
            mercado e da indústria da moda. Para ela, a única maneira de evoluir
            é por meio do completo desapego das formas e fórmulas existentes.
          </p>
        </S.Text>
        <Gallery04 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            “Cheguei a um ponto em que senti que não poderia criar nada sem
            mudar meu pensamento radicalmente”, disse a estilista após o desfile
            de verão 2014, em Paris. “A única maneira de fazer algo novo é não
            fazer roupas.” De lá para cá, a diretora de criação se manteve mais
            ou menos fiel a tal pensamento. Algumas coleções pendem para o lado
            criativo sem nenhuma consideração para o que se entende como algo
            vestível, enquanto outras se desenvolvem sobre códigos já bem
            conhecidos.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            O inverno 2022 se apresenta mais equilibrado entre os dois extremos.
            É possível reconhecer os traços de um sobretudo, o desenho de um
            tailleur, a linha de um vestido longo, mas é visível e sensível a
            ruptura criativa para além dos moldes convencionais. Muitas das
            roupas parecem rompidas, abertas como que para dar vazão a um volume
            interno algo desregulado, orgânico, livre. Com isso, Rei redesenha
            mais uma vez a silhueta feminina. Amplia quadris, ressalta
            corcundas, infla bustos, reduz ombros, alonga braços.
          </p>
        </S.Text>
        <Gallery05 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Como na histórica coleção de verão 1997 – e em tantas outras –, o
            entendimento ou a imposição do belo são colocados em xeque. Nesta
            talvez de maneira mais próxima ou assimilável, com o fator do choque
            ou da repulsa reduzido pela proximidade com que algumas peças mantêm
            com o que tomamos como aceitável e possível. Dificilmente veremos
            essas roupas nas ruas, é verdade. Mas as ideias estão aí. São
            questionamentos e provocações menos imediatas do que as tendências
            mais quentes do momento, porém extremamente mais transformadoras.
            Afinal, quantas vezes você não se pegou usando algo que nunca
            imaginou?
          </p>
        </S.Text>
        <S.Separator />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Raio-X de um desfile é a uma seção fixa da ELLE View, em que todos
            os meses examinamos uma apresentação recente, trazendo detalhes
            sobre as roupas e explicando por que vale a pena você saber mais
            sobre ela.
          </p>
        </S.Text>
      </S.Content>
    </S.Container>
  );
};

export default Main;
